require('./dist/qw-zoom.js');

module.exports = 'qwZoomModule';


//////////////////
// WEBPACK FOOTER
// ./~/@qwentes/angularjs-qw-zoom/index.js
// module id = 249
// module chunks = 0